// Current birthday-party information supplied in the official 2026 contract.

export const PARTY_PACKAGES = [
  {
    id: 'kids-zone',
    name: 'Kids Zone Party',
    price: 360,
    duration: '2 hours',
    days: 'Friday, Saturday & Sunday after 2:00 PM',
    includes: [
      'Playroom area',
      '1 party attendant',
      '20 children, including the birthday child and siblings',
      'Tables, chairs, and refrigerator provided',
    ],
  },
  {
    id: 'kids-zone-beach',
    name: 'Kids Zone & Beach Party',
    price: 430,
    duration: '2 hours',
    days: 'Saturday & Sunday after 2:00 PM',
    includes: [
      'Playroom area',
      'Lesson Pool',
      '2 party attendants',
      '20 children, including the birthday child and siblings',
      'Tables, chairs, and refrigerator provided',
    ],
  },
];

export const PARTY_EXTRAS = [
  { id: 'extra-30', label: 'Additional 30 minutes of party time', price: 45 },
  { id: 'extra-60', label: 'Additional 1 hour of party time', price: 80 },
  { id: 'extra-kid', label: 'Each additional child over 20', price: 15 },
  { id: 'extra-attendant', label: 'Additional party attendant', price: 25 },
  {
    id: 'lifeguard',
    label: 'Certified lifeguard / swim instructor',
    price: 35,
    packageNote: 'Kids Zone & Beach Party only',
  },
];

export const PARTY_POLICY_GROUPS = [
  {
    title: 'Entering, exiting, food, and setup',
    items: [
      'Waivers must be signed before entry for all guests and party hosts.',
      'The party host may enter and set up 30 minutes before the party begins.',
      'Hosts may bring their own food and drinks.',
      'One refrigerator/freezer is available for food and beverage storage.',
      'Party staff provide a 10–15 minute reminder before the party ends.',
      'Hosts must remove all belongings and food when the party ends; items left behind will be discarded.',
      'Food, drinks, and toys are not allowed in the play structures.',
    ],
  },
  {
    title: 'Swim party rules',
    items: [
      'Party attendants are not lifeguards; they are responsible for relaying rules only.',
      'There is no lifeguard on duty unless the certified lifeguard / swim instructor add-on is purchased.',
      'No running in the pool area and no forward or back flips into the pool.',
      'Guests may not leave the pool area or locker rooms unless they are dried off.',
      'Guests may not use aqua equipment.',
      'No metal toys are allowed in the pool.',
      'No glass products are allowed on the pool deck or in the pool.',
      'No food or drinks are allowed on the pool deck.',
      'Children under age 3, or children who cannot stand in 3-foot water, must wear a life belt or have a parent in the water with them at all times.',
    ],
  },
  {
    title: 'Basketball and activity-area rules',
    items: [
      'Delta Valley Health Club is not responsible for personal items left in the Childcare Center.',
      'Children may not climb on the rock wall without a rock-climbing attendant.',
      'No food or drinks are allowed in the rock-climbing area.',
      'Guests may not touch workout equipment.',
    ],
  },
];

export const PARTY_IMPORTANT_TERMS = [
  'A 50% non-refundable deposit is required upon booking to secure the party; guests may also pay in full.',
  'The remaining balance is due at the time of the party.',
  'Additional time, guests, attendants, or lifeguard / swim instructor add-ons cannot be refunded or deducted from the remaining balance.',
  'A $45 fee applies if the scheduled party time is exceeded.',
  'Extra time may not be added on the day of the party.',
  'Children remain the responsibility of their parent or guardian. Party staff assist with the party only.',
  'Every child must have a waiver signed by a parent to attend.',
];
